// deployment_class: customer_env_allowed
/**
 * Footer — the site footer for Kathedral.ai's public landing surface (Version B).
 *
 * Composition adapted from the "Circuit Horizon" reference (E3 2026-08-01) into
 * the CURRENT glass design system: the hero-CTA panel replicates .glass-card's
 * exact opacity + transparency (see footer.css) so it matches the login/landing
 * glass 1:1, floating over the photographic backdrop; the link columns sit on a
 * clean paper band below so every label clears WCAG 2.2 AA. Tokens only; motion
 * is prefers-reduced-motion aware; links are keyboard-operable with a visible
 * focus ring.
 */
import './footer.css';

export function Footer(): JSX.Element {
  return (
    <footer className="kh-footer" aria-labelledby="kh-footer-lede">
      {/* hero-CTA glass panel — floats over the photographic backdrop */}
      <div className="kh-footer-wrap kh-hero-wrap">
        <div className="kh-panel-wrap">
          <span className="kh-badge">
            <svg className="kh-spark" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 2l1.9 5.6L19.5 9l-4.6 3.3L16 18l-4-3.4L8 18l1.1-5.7L4.5 9l5.6-1.4L12 2z"
                fill="currentColor"
              />
            </svg>
            Built for PHA leadership
          </span>

          <section className="kh-panel">
            <span className="kh-mark" aria-hidden="true">
              K
            </span>

            <div className="kh-lede">
              <h2 id="kh-footer-lede">
                Structured partnerships.
                <br />
                Provable outcomes.
                <br />
                <span className="kh-accent">One executive anchor.</span>
              </h2>
            </div>

            <div className="kh-aside">
              <p>
                The anchor for every PHA–developer partnership — structured, transparent, and
                provable end to end.
              </p>
              <div className="kh-cta-row">
                <a className="kh-cta" href="#">
                  Explore Kathedral
                  <span className="kh-dots" aria-hidden="true">
                    <i />
                    <i />
                    <i />
                  </span>
                </a>
                <a className="kh-ghost" href="#">
                  <span className="kh-play" aria-hidden="true" /> Take me on a tour
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* paper band — link columns + baseline, legible over any backdrop */}
      <div className="kh-lower">
        <div className="kh-footer-wrap">
          <div className="kh-cols">
            <div className="kh-brand">
              {/* logo mark ALWAYS beside the name, side by side (brand rule · E3) */}
              <div className="kh-logo">
                <img src="/kathedral-logo.png" alt="" aria-hidden="true" className="kh-logo-mark" />
                <span className="kh-logo-text">
                  Kathedral<span className="kh-ai">.ai</span>
                </span>
              </div>
              <p>The executive intelligence platform for public housing authority leadership.</p>
              <span className="kh-verified">
                <span className="kh-tick" aria-hidden="true">
                  ✓
                </span>{' '}
                Kathedral Verified marketplace
              </span>
            </div>

            <nav className="kh-col" aria-label="Portals">
              <h3>Portals</h3>
              <a href="#">Marketplace</a>
              <a href="#">Partnership</a>
              <a href="#">Sales</a>
              <a href="#">Data Analytics</a>
            </nav>

            <nav className="kh-col" aria-label="Platform">
              <h3>Platform</h3>
              <a href="#">Ask Kathedral</a>
              <a href="#">Kathedral IQ</a>
              <a href="#">Verify me</a>
              <a href="#">Workflows</a>
            </nav>

            <nav className="kh-col" aria-label="Company">
              <h3>Company</h3>
              <a href="#">Trust &amp; Security</a>
              <a href="#">About</a>
              <a href="#">Contact</a>
              <a href="#">Careers</a>
            </nav>
          </div>

          <div className="kh-baseline">
            <span>© 2026 Kathedral.ai · Purpose-built for PHA–developer Co-GP deals.</span>
            <nav aria-label="Legal">
              <a href="#">Privacy</a>
              <a href="#">Terms</a>
              <a href="#">Accessibility</a>
              <a href="#">Status</a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
